'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.StorageService
 * @description
 * # StorageService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('StorageService', function() {
  return {
    set: function(key, value) {
      if (typeof(value) === 'string') {
        localStorage.setItem(key, value);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    },

    get: function(key, defaultValue) {
      var value = localStorage.getItem(key);
      if (!value && defaultValue) {
        return defaultValue;
      }

      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    },

    clear: function() {
      const dashboard = this.get(DASHBOARD_STORAGE_KEY);
      localStorage.clear();

      if (dashboard) {
        this.set(DASHBOARD_STORAGE_KEY, dashboard);
      }
    },

    remove: function(key){
      localStorage.removeItem(key);
    }

  };
});
